<template>
  <div>
    <lm-image1 :shadow="false" :scale="false" :src="f1">
      <div slot="title">We are committed to making a world-class education affordable.</div>
    </lm-image1>
    <lm-swatches-block :space="43.75">
      <lm-container>
        <h2>Scholarship</h2>
    <!-- <lm-container class="u_separation" :width="1500">
      <p>We are committed to making a world-class education affordable.</p>
    </lm-container> -->
        <lm-row :md-gutter="35">
          <lm-col :md-span="8" v-for="article in module1" :key=article.id>
            <lm-column2
              style="margin-bottom: 35px;"
              :src="article.article_pic_syn"
              :title="article.title"
              :description="article.intro"
              :links="article.articles"
            ></lm-column2>
          </lm-col>
        </lm-row>
        <lm-row :md-gutter="35">
          <lm-col :md-span="8" v-for="article in module2" :key=article.id>
            <lm-column2
              style="margin-bottom: 35px;"
              :src="article.article_pic_syn"
              :title="article.title"
              :description="article.intro"
              :links="article.articles"
            ></lm-column2>
          </lm-col>
        </lm-row>
      </lm-container>
    </lm-swatches-block>
    <poster-module :type="2"></poster-module>
  </div>
</template>

<script>
import { frontArticles4Memu, frontThrMenu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';
import PosterModule from '../column/components/PosterModule';

export default {
  components: {
    PosterModule
  },
  mixins: [methodsMixins],
  data() {
    return {
      f1: require('@/assets/temp/f1.jpg'),
      b18: require('@/assets/temp/b18.jpg'),
      b19: require('@/assets/temp/b19.jpg'),
      src1: require('@/assets/scholarship/scholarship1.png'),
      src2: require('@/assets/scholarship/scholarship2.png'),
      src3: require('@/assets/scholarship/scholarship3.png'),
      src4: require('@/assets/scholarship/scholarship4.png'),
      module1: [],
      module2: []
    }
  },
  created() {
    // const list1 = [],
    // list2 = [],
    // list3 = [],
    // list4 = [];
    // this.getArticles('y0lm76nibq', 'y0m5xn80ui', list1);
    // this.getArticles('y0lm76nibq', 'y0m64qb2ag', list2);
    // this.getArticles('y0lm76nibq', 'y0m64qappj', list3);
    // this.getArticles('y0lm76nibq', 'y0m64qa9qk', list4);
    const { src1, src2, src3, src4 } = this;
    this.module1 = [{
      title: 'CSC Scholarship',
      intro: 'Chinese government has set up a series of scholarship programs to sponsor international students, teachers and scholars to study and conduct research in Chinese universities.',
      article_pic_syn: src1,
      articles: [{
        article_title: 'More About Scholarships',
        id: 'y0m64q0r1z'
      }]
    }, {
      title: 'SMU President Scholarship for Freshmen',
      intro: 'First Prize: Full scholarship, exemption from tuition fee and provided with stipend.',
      article_pic_syn: src2,
      articles: [{
        article_title: 'More About Scholarships',
        id: 'y0m64qfy5i'
      }]
    }];
    this.module2 = [{
      title: 'GD Govt. Scholarship for Freshmen',
      intro: 'The amount of awards varies from ¥10,000 to ¥30,000.',
      article_pic_syn: src3,
      articles: [{
        article_title: 'More About Scholarships',
        id: 'y0m64qfy5i'
      }]
    }, {
      title: 'SMU Scholarship for Freshmen',
      intro: 'The amount of awards varies from ¥10,000 to ¥30,000.',
      article_pic_syn: src4,
      articles: [{
        article_title: 'More About Scholarships',
        id: 'y0m64qfy5i'
      }]
    }]
  }
}
</script>